module.exports = __webpack_public_path__ + "static/media/ar.4da4346a.svg";